import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { TReturnItemTableRow } from './types';

export const returnItemTableStructure: TTableStructure<
	keyof TReturnItemTableRow,
	TReturnItemTableRow
>[] = [
	{
		selector: 'id_provided_by_em',
		name: 'Item ID',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'short_description',
		name: 'Product Name',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
		colSpan: 2,
	},
	{
		selector: 'rep_scheme',
		name: 'Representation Scheme',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'report_type',
		name: 'Report Type',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'return_item_quantity',
		name: 'Quantity',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		selector: 'return_item_amount',
		name: 'Item Amount',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		currency: (item) => item.payment_currency_code ?? 'EUR',
	},
	{
		selector: 'return_delivery_cost',
		name: 'Delivery Charge',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		currency: (item) => item.payment_currency_code ?? 'EUR',
	},
	{
		selector: 'return_vat_value',
		name: 'Item VAT',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		currency: (item) => item.payment_currency_code ?? 'EUR',
	},
	{
		selector: 'return_vat_on_delivery_charge',
		name: 'VAT on Delivery',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		currency: (item) => item.payment_currency_code ?? 'EUR',
	},
	{
		selector: 'return_eas_fee',
		name: 'EAS Fee',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		currency: (item) => item.payment_currency_code ?? 'EUR',
	},
	{
		selector: 'return_vat_on_eas_fee',
		name: 'VAT on EAS Fee',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		currency: (item) => item.payment_currency_code ?? 'EUR',
	},
	{
		selector: 'return_item_amount',
		name: 'Total',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		value: (item) =>
			String(
				(item.return_item_amount ?? 0) +
					(item.return_vat_value ?? 0) +
					(item.return_eas_fee ?? 0) +
					(item.return_vat_on_eas_fee ?? 0) +
					(item.return_delivery_cost ?? 0) +
					(item.return_vat_on_delivery_charge ?? 0),
			),
		currency: (item) => item.payment_currency_code ?? 'EUR',
	},
];
